import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PnlPage from '../../pages/pnl/PnlPage';
import PnlSummaryPage from '../../pages/pnl-summary/PnlSummaryPage';
import AbpPage from '../../pages/abp/AbpPage';
import CustomerAnalysisPage from '../../pages/customer-analysis/CustomerAnalysisPage';
import OuAnalysisPage from '../../pages/ou-analysis/OuAnalysisPage';
import UsersPage from '../../pages/users/UsersPage';
import RolesPage from '../../pages/roles/RolesPage';
import Layout from '../../components/layout';
import LoginPage from '../../pages/login/LoginPage';
import CustomerDataPage from '../../pages/customer-data/CustomerDataPage';
import BranchDataPageWrapper from "../../pages/customer-data/BranchDataPageWrapper"
import { useAuth } from 'contexts/AuthContext';
import { CustomerDataFiltersProvider } from 'contexts/CustomerDataFiltersContext';

function FullScreenSpinner() {
  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
    </div>
  );
}

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, authLoading } = useAuth();
  if (authLoading) return <FullScreenSpinner />;
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, authLoading } = useAuth();
  if (authLoading) return null;
  return !isAuthenticated ? <>{children}</> : <Navigate to="/" replace />;
};

const DefaultRoute: React.FC = () => {
  // Using permissions in future; for now default to pnl
  return <Navigate to="/reports/pnl" replace />;
};

const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/" element={<ProtectedRoute><DefaultRoute /></ProtectedRoute>} />
      <Route path="/dashboard/customer-analysis" element={<ProtectedRoute><Layout><CustomerAnalysisPage /></Layout></ProtectedRoute>} />
      <Route path="/dashboard/ou-analysis" element={<ProtectedRoute><Layout><OuAnalysisPage /></Layout></ProtectedRoute>} />
      <Route path="/reports/pnl" element={<ProtectedRoute><Layout><PnlPage /></Layout></ProtectedRoute>} />
      <Route path="/reports/performance-comparison" element={<ProtectedRoute><Layout><PnlSummaryPage /></Layout></ProtectedRoute>} />
      <Route path="/reports/abp" element={<ProtectedRoute><Layout><AbpPage /></Layout></ProtectedRoute>} />
      <Route path="/settings/users" element={<ProtectedRoute><Layout><UsersPage /></Layout></ProtectedRoute>} />
      <Route path="/settings/roles" element={<ProtectedRoute><Layout><RolesPage /></Layout></ProtectedRoute>} />
      <Route path="/reports/customer-data" element={<ProtectedRoute><Layout><CustomerDataFiltersProvider><CustomerDataPage /></CustomerDataFiltersProvider></Layout></ProtectedRoute>} />
      <Route path="/reports/customer-data/branches" element={<ProtectedRoute><Layout><CustomerDataFiltersProvider><BranchDataPageWrapper /></CustomerDataFiltersProvider></Layout></ProtectedRoute>} />
    </Routes>
  );
};

export default AppRouter;
